import '../../../resources/css/admin_style.css';
import styles from './component.module.css';
import { useState } from 'react';
import EditModal from './modal/EditModal';
import { IAM_SERVER_UNIFIEDPROFILE } from '../../../utils/Config';
import axios from "../../../utils/api/axios";
import { DialogEnum, showDialog } from '../../../utils/dialog/Dialog';
import { countries, getCountryDisplayName, getCountryKoreanName} from '../../../utils/countries/countries';
import { getCookie } from '../../../utils/cookies/cookies';

/**
 * 기본정보 판넬
 * @param callback
 * @param delay
 */
function AddressInfoPanel({ user, onUserUpdate }) {
  const [showModal, setShowModal] = useState(false);
  const [address, setAddress] = useState(user?.address || "");
  const [addressDetail, setAddressDetail] = useState(user?.address_detail || "");
  const [city, setCity] = useState(user?.city || "");
  const [state, setState] = useState(user?.state || "");
  const [postNumber, setPostNumber] = useState(user?.postNumber || "");
  const [country, setCountry] = useState(user?.country || "");


  const handleEdit = () => {
    setAddress(user?.address || "");
    setAddressDetail(user?.address_detail || "");
    setCity(user?.city || "");
    setState(user?.state || "");
    setPostNumber(user?.postNumber || "");
    setCountry(user?.country || "");
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const saveChange = () => {
    const userId = getCookie("user_id");

    const params = {
      unifiedProfileId: userId,
      address: address,
      addressDetail: addressDetail,
      city: city,
      state: state,
      postNumber: postNumber,
      country: country,
    };

    axios.post(`${IAM_SERVER_UNIFIEDPROFILE}/update`, params)
      .then((res) => {
        showDialog(DialogEnum.SUCCESS, "성공", res.data.message, closeModal);

        if (typeof onUserUpdate === "function") {
          onUserUpdate(true);
        }
      })
      .catch((e) => {
        showDialog(DialogEnum.DEFAULT, "실패", e.response?.data?.resultMessage || "오류 발생");
      });

    closeModal();
  };

  const formatFullAddress = (addr) => {
    if (!addr.address) return "";
    
    // ✅ 국가 코드를 국가 이름으로 변환
    const countryName = addr.country === 'KR' 
        ? getCountryKoreanName(addr.country) 
        : getCountryDisplayName(addr.country);

    const parts = [
      addr.address,
      addr.addressDetail,
      addr.city,
      addr.state,
      addr.postNumber,
      countryName, // ✅ 변환된 국가 이름 사용
    ];
    return parts.filter(Boolean).join(', ');
  };

  const fullAddress = formatFullAddress(user);

  return (
    <div className={styles.infoCard}>
      <h2 className={styles.infoTitle}>주소</h2>

      <div className={styles.infoItem} onClick={handleEdit}>
        <span className={styles.infoItemLabel}>주소</span>
        <span className={styles.infoItemValue}>
          {fullAddress || "설정되지 않음"} <span className={styles.editArrow}>&gt;</span>
        </span>
      </div>

      {showModal && (
        <EditModal
          title="주소"
          type="global_address"
          value={{
            address: address,
            addressDetail: addressDetail,
            city: city,
            state: state,
            postNumber: postNumber,
            country: country
          }}
          onChange={(updated) => {
            setAddress(updated.address);
            setAddressDetail(updated.addressDetail);
            setCity(updated.city);
            setState(updated.state);
            setPostNumber(updated.postNumber);
            setCountry(updated.country);
          }}
          onClose={closeModal}
          onSave={saveChange}
        />
      )}
    </div>
  );
}

export default AddressInfoPanel;